import * as $ from 'jquery';

function initModalFunctions() {

  if ($(".modal__toptaak-popover select").length > 0) {
    $(".modal__toptaak-popover select").change(function (event) {
      location.href = (<any> this).value;
    });
  }
  
}

export { initModalFunctions };